module.exports = __webpack_public_path__ + "static/mark-collins-904fcd0ccdcd919fa08a2870db4d7bd4.jpg";